import { ResultsQuantity, SortBy, TabFilter } from '@/features/shared';
import ElasticComponentContext from '@/features/shared/ElasticComponent/ElasticComponentContext';
import { MuiTypography } from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, useContext } from 'react';
import useStyles from './HeaderMobile.styles';

export type Props = {
  labels?: Record<string, string>;
};

const HeaderMobileContent = ({ labels }: Props) => {
  const classes = useStyles({});
  const { queryParams } = useContext(ElasticComponentContext);
  const { q: query } = queryParams || {};

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {query && (
          <MuiTypography
            variant="h2"
            component="span"
            className={clsx(classes.query, !query && 'is-empty')}
          >
            {query ? `“${query}”` : <span>&nbsp;</span>}
          </MuiTypography>
        )}
        <div className={classes.row}>
          <ResultsQuantity />
          <div className={classes.sortBy}>
            <SortBy theme={Theme.light} />
          </div>
        </div>
      </div>
      <TabFilter labels={labels} theme={Theme.dark} size="small" />
    </div>
  );
};

export default memo(HeaderMobileContent);
